import axios from 'axios'
import utils from './utils'
import commonService from './commonService'

const getAll = async (signal = null) => {
  const url = utils.url + '/member_cards'
  return await commonService.load(url, signal)
}

const get = async (id, signal = null) => {
  const url = `${utils.url}/member_cards/${id}`
  return await commonService.load(url, signal, null)
}

const add = async (instance, signal = null) => {
  return await commonService.add('member_cards', instance, signal)
}

const update = async (instance, signal = null) => {
  return await commonService.update('member_cards', instance, signal)
}

const delete_ = async (instance, signal = null) => {
  return await commonService.delete_('member_cards', instance.id, signal)
}

const deleteOfMember = async (member, signal = null) => {
  const url = `${utils.url}/members/${member.id}/delete_card`
  try {
    const params = {}
    if (signal) params.signal = signal
    const res = await axios.delete(url, null, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return null
  }
}

const setPrint = async (instance, signal = null) => {
  const url = `${utils.url}/member_cards/${instance.id}/set_print`
  try {
    const params = {}
    if (signal) params.signal = signal
    const res = await axios.put(url, {}, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return null
  }
}

const allowReprint = async (instance, signal = null) => {
  const url = `${utils.url}/member_cards/${instance.id}/allow_reprint`
  try {
    const params = {}
    if (signal) params.signal = signal
    const res = await axios.put(url, {}, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return null
  }
}

const getLastByOrgane = async (organeType, organeId, limit = 10, signal = null) => {
  const url = `${utils.url}/member_cards/last/${limit}/${organeType}/${organeId}`
  return await commonService.load(url, signal, [])
}

const getAllInPeriodByOrganeFromSo = async (
  organeType,
  organeId,
  fromDate,
  toDate,
  offset = 0,
  limit = 10,
  cardTypeId = 'ALL',
  printType = 'ALL',
  signal = null,
) => {
  const url = `${utils.url}/member_cards/in/${fromDate}/${toDate}/fromso/${offset}-${limit}/${organeType}/${organeId}/${cardTypeId}/${printType}`
  return await commonService.load(url, signal, [])
}

const getAllInPeriodByOrganeReport = async (
  organeType,
  organeId,
  fromDate,
  toDate,
  cardTypeId = 'ALL',
  printType = 'ALL',
  signal = null,
) => {
  const url = `${utils.url}/member_cards/report/by/federation/in/${fromDate}/${toDate}/${organeType}/${organeId}/${cardTypeId}/${printType}`
  return await commonService.load(url, signal, [])
}

const getAllInPeriodOfOrganeByMemberReport = async (
  organeType,
  organeId,
  fromDate,
  toDate,
  cardTypeId = 'ALL',
  printType = 'ALL',
  signal = null,
) => {
  const url = `${utils.url}/member_cards/report/by/member/in/${fromDate}/${toDate}/${organeType}/${organeId}/${cardTypeId}/${printType}`
  return await commonService.load(url, signal, [])
}

const countInPeriodByOrgane = async (
  organeTypeId,
  organeId,
  fromDate,
  toDate,
  cardTypeId = 'ALL',
  printType = 'ALL',
  signal = null,
) => {
  const url = `${utils.url}/member_cards/count/in/${fromDate}/${toDate}/${organeTypeId}/${organeId}/${cardTypeId}/${printType}`
  return await commonService.load(url, signal, 0)
}

const getAllByOrganeFromSoPattern = async (
  organeType,
  organeId,
  pattern,
  offset = 0,
  limit = 10,
  signal = null,
) => {
  const url = `${utils.url}/member_cards/fromso/${offset}-${limit}/${organeType}/${organeId}/${pattern}`
  return await commonService.load(url, signal, [])
}

const getOfMember = async (member, signal = null) => {
  const url = `${utils.url}/member_cards/ofMember/${member.id}`
  return await commonService.load(url, signal, null)
}

const getAllUnaffectedByPattern = async (pattern, offset = 0, limit = 10, signal = null) => {
  const url = `${utils.url}/member_cards/unaffected/fromso/${offset}-${limit}/${pattern}`
  return await commonService.load(url, signal, [])
}

const getAllUnaffected = async (offset = 0, limit = 10, signal = null) => {
  const url = `${utils.url}/member_cards/unaffected/fromso/${offset}-${limit}`
  return await commonService.load(url, signal, [])
}
/*
 ** Count member_cards and group by the organe's children
 */
const countByOrganeAndPattern = async (organeType, organeId, pattern, signal = null) => {
  const url = `${utils.url}/member_cards/count/${organeType}/${organeId}/${pattern}`
  return await commonService.load(url, signal, 0)
}

const countUnaffectedByPattern = async (pattern, signal = null) => {
  const url = `${utils.url}/member_cards/count/unaffected/${pattern}`
  return await commonService.load(url, signal, 0)
}

const countUnaffected = async (signal = null) => {
  const url = `${utils.url}/member_cards/count/unaffected`
  return await commonService.load(url, signal, 0)
}

const countAndGroupByOrgane = async (organeType, organeId, signal = null) => {
  const url = `${utils.url}/member_cards/count-and-group/${organeType}/${organeId}`
  return await commonService.load(url, signal, [])
}

const countAllInYear = async (year, signal = null) => {
  const url = utils.url + '/member_cards/count/years/' + year
  return await commonService.load(url, signal, [])
}

/*
 ** Count all entries and group by years, months and days
 */
const countAllLast = async (date, signal = null) => {
  const url = utils.url + '/member_cards/count/all/' + date
  return await commonService.load(url, signal, {})
}

const countAllLastByOrgane = async (date, organeType, organeId, signal = null) => {
  const url = `${utils.url}/member_cards/count/all/${date}/${organeType}/${organeId}`
  return await commonService.load(url, signal, {})
}

const countAllByOrgane = async (organeType, organeId, signal = null) => {
  const url = `${utils.url}/member_cards/count/${organeType}/${organeId}`
  return await commonService.load(url, signal, {})
}

export default {
  getAll,
  get,
  countAllLast,
  countAndGroupByOrgane,
  countAllLastByOrgane,
  countAllByOrgane,
  countAllInYear,
  countByOrganeAndPattern,
  getLastByOrgane,
  getAllInPeriodByOrganeFromSo,
  getAllInPeriodOfOrganeByMemberReport,
  countInPeriodByOrgane,
  getAllByOrganeFromSoPattern,
  getAllInPeriodByOrganeReport,
  add,
  update,
  delete_,
  countUnaffected,
  countUnaffectedByPattern,
  getAllUnaffected,
  getAllUnaffectedByPattern,
  setPrint,
  allowReprint,
  getOfMember,
  deleteOfMember,
}
